import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Form, Field } from 'react-final-form';
import { ToastContainer, notify } from '../../libraries/notifications';
import config from '../../config';
import Swal from 'sweetalert2';

import LayoutWithSidebar from '../../components/layout/LayoutWithSidebar';
import Icon from '../../libraries/icons';
import ProfessionalCard from '../../components/customs/ProfessionalCard';
import SearchInput from '../../components/forms/SearchInput';
import Loader from '../../components/commons/Loader';

import userActions from '../../context/users/actions';

class Professionals extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
      professionals: [],
      search: "",
      filters: {
        specialty: ""
      }
    }
  }
  
  componentDidMount() {
    console.log('MY PRESCRIPTIONS PAGE');
    this.getProfessionals();
  }

  getProfessionals = async () => {
    const {search, filters} = this.state
    const params = { user_type: config.USER_TYPE.PROFESSIONAL, status: config.TYPES.ACTIVE, enabled: 1 }

    if ((search && search !== "") || (filters.specialty && filters.specialty !== "")){
      this.setState({ professionals: [] });
      params.where = {"json_data":[]};
      if (filters.specialty && filters.specialty !== ""){
        params.where.json_data.push({"field":"specialty", "value":filters.specialty})
      }
      if (search && search !== "") {
        //params.where.json_data.push({"field":"name", "value":`%${search}`, "comparison": "LIKE",})
        if(!params.where.json_data){
          params.where = { custom: { name: `%${search.toLowerCase()}`,} };
        } else {
          params.name = `%${search.toLowerCase()}`
        }
      }
      if(!params.where.json_data.length){
        delete params.where.json_data
      }
    }


      
    await this.props.onGetAllProfessionals(params);
    const { professionals } = this.props;
    if (professionals.error) { 
      notify(this.t(professionals.error.message));
    } else {
      this.setState({ professionals: professionals.items });
    }    
  }

  setFilter = async () => {
    console.log('set filter');
    const { value: formValues } = await Swal.fire({
        title: this.t("Filtros"),
        html:
        '<input id="tipo-consulta" class="swal2-input" type="radio" value="video" name="tipoconsulta">' +
        '<label for="video">Video</label>'+
        '<input id="tipo-consulta" class="swal2-input" type="radio" value="presencial" name="tipoconsulta">' +
        '<label for="presencial">Presencial</label>'+
        '<br><label for="distance">Fecha</label>' +
        '<br><label>Día</label>' +
        '<input id="date" class="swal2-input" type="date" name="date">' +
        '<label>Hora</label>' +
        '<br><label for="distance">Distance</label>' +
        '<input id="distance" class="swal2-input" type="range" name="distance" min="0" max="5">',

        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: this.t("Filtrar"),

        preConfirm: () => {
            return {
                type: document.getElementById('tipo-consulta').value,
                distance: document.getElementById('distance').value,
                date: document.getElementById('date').value,
            }
          }
    })
    
    if(formValues){
        console.log(JSON.stringify(formValues))
        //Swal.fire(JSON.stringify(formValues))

        this.setState({filters: formValues})
    }
  }

  searchClear = (form) => {
    form.change('search', undefined);
    this.searchOnClick({search: ''});
  }

  searchOnClick = async (values) => {
    console.log("Search on Click", values.search);
    if (this.state.search !== values.search) this.setState({ search: values.search || '' }, () => this.getProfessionals() );
  };

  filterProfessionals(specialty){
    if(specialty === this.state.filters.specialty){
      this.setState({filters:{...this.state.filters,specialty:""}}, () => this.getProfessionals())
    } else {
      this.setState({filters:{...this.state.filters,specialty}}, () => this.getProfessionals())
    }
    
  }
  
  render() {
    const { professionals, filters } = this.state;
    let speciality_types = config.OPTIONS.SINGUP.SPECIALTIES.TYPES;

    return (
      <LayoutWithSidebar
        main={{ className: "bg-base-200"}}
        header={{ 
          title: this.t("Profesionales"),
          // right: { icon: 'adjustments', action: this.setFilter },

        }}
        container={{ className: "px-0"}}
        // loading={this.props.professionals.loading}
      >
        <ToastContainer/>
        <section className="h-10 bg-primary"></section>
        <section className="section-card">
          <Form initialValues={{}} onSubmit={this.searchOnClick}>
            {({ handleSubmit, form, submitting, pristine, values }) => (
              <form onSubmit={handleSubmit} className="w-full max-w-lg mx-auto mb-4">
                <Field name="search" component={SearchInput} placeholder={this.t("Search")} onClick={this.searchOnClick} onClearClick={() => this.searchClear(form) }/>
              </form>
            )}
          </Form>
          <div className="scrolling-wrapper py-3">
            {speciality_types.map((specialty, index) => { 
              return (
                <div
                  key={`specialty${index}`}
                  className={"card white py-2 px-4 mb-4 w-22 mr-4 border-2 border-transparent " + (specialty===filters.specialty ? " border-accent text-accent" : " text-gray-400") + ""}
                  onClick={() => this.filterProfessionals(specialty)}
                >
                  <p>{specialty}</p>
                </div>
              );
            })}
          </div>
          <div>
            { this.props.professionals.loading && (<Loader/>) }
            { !this.props.professionals.loading && professionals.length === 0 && (
              <div className="text-center p-10">
                <Icon className="h-24 w-24 mx-auto mb-3" name="stethoscope" />
                <h4 className="mb-1">{this.t("No hay profesionales")}</h4>
              </div>
            ) }
            { professionals.map((professional, index) => 
              <ProfessionalCard
                  key={index}
                  route={`${config.ROUTES.PROFESSIONALS}/${professional.id}`}
                  professional={professional}
                  className="border-b p-4"
                />
            )}
          </div>
        </section>
      </LayoutWithSidebar>      
    ) 
  }
}

const mapStateToProps = state => {
  return {
    auth: state.users.auth,
    professionals: state.users.list,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onGetAllProfessionals: (params) => dispatch(userActions.getAll(params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(Professionals));
